export default "__VITE_ASSET__OtXmCliU__"